import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M12.689 7.953a.75.75 0 0 0-1.378 0l-1.072 2.485-2.797.215a.75.75 0 0 0-.42 1.326l2.112 1.744-.644 2.597a.75.75 0 0 0 1.109.826L12 15.733l2.401 1.413a.75.75 0 0 0 1.109-.826l-.643-2.597 2.11-1.744a.75.75 0 0 0-.42-1.326l-2.796-.215zm-1.252 3.495L12 10.143l.563 1.305a.75.75 0 0 0 .631.45l1.395.108-1.042.86a.75.75 0 0 0-.25.759l.328 1.324-1.245-.732a.75.75 0 0 0-.76 0l-1.245.732.328-1.324a.75.75 0 0 0-.25-.759l-1.042-.86 1.395-.108a.75.75 0 0 0 .631-.45"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M17.25 2.25a.75.75 0 0 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3h-1.5A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3h-1.5zm-10.5 3V4.5h-1.5a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75h-1.5v.75a.75.75 0 0 1-1.5 0V4.5h-7.5v.75a.75.75 0 0 1-1.5 0"
      clipRule="evenodd"
    />
  </>
);

const CalenderStar = Icon('calender-star', svgContents);

export default CalenderStar;
